import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ChevronRightIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70041 16.2603C9.41856 15.9568 9.43613 15.4823 9.73966 15.2004L12.6478 12.5L9.73966 9.79959C9.43613 9.51774 9.41856 9.04319 9.70041 8.73966C9.98226 8.43612 10.4568 8.41855 10.7603 8.7004L14.2603 11.9504C14.4132 12.0923 14.5 12.2914 14.5 12.5C14.5 12.7085 14.4132 12.9077 14.2603 13.0496L10.7603 16.2996C10.4568 16.5814 9.98226 16.5639 9.70041 16.2603Z"
        fill="currentColor"
      />
    </svg>
  );
};
